import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {
	const relatedPosts = {
		init: function() {
			this.$slider = $('.js-related-posts-slider');
			this.sliderInit();
		},

		sliderInit: function() {
			if (!this.$slider.length) {
				return;
			}

			this.$slider.on('init reInit afterChange', (event, slick, currentSlide) => {
				const index = (currentSlide || 0) + 1;
				const current = String(index).padStart(2, '0');
				const total = String(slick.slideCount).padStart(2, '0');

				slick.$slider.closest('.related-posts').find('.js-related-posts-counter').text(`${current} / ${total}`);
			});

			const sliderConfig = {
				slidesToShow: 3,
				slidesToScroll: 1,
				speed: 650,
				infinite: false,
				autoplay: false,
				arrows: true,
				prevArrow: '.js-related-posts-prev',
				nextArrow: '.js-related-posts-next',
				rows: 0,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1
						}
					}
				]
			};

			sliders.initializeSlider('.js-related-posts-slider', sliderConfig);
		}
	};

	relatedPosts.init();
});
